<template>
  <div class="department-print-page">
    <header class="print-toolbar">
      <div>
        <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回填写页</el-button>
        <strong>{{ payload ? payload.title : '最终合同' }}</strong>
      </div>
      <div class="pdf-actions">
        <span>在浏览器打印窗口中选择“另存为 PDF”</span>
        <el-button type="primary" icon="el-icon-document" :disabled="loading || Boolean(loadError) || !payload" @click="savePdf">保存PDF</el-button>
      </div>
    </header>
    <div v-if="loading" class="print-missing" v-loading="loading">正在获取最终合同数据</div>
    <main v-else-if="payload" class="print-preview" v-html="documentHtml"></main>
    <div v-else class="print-missing print-error">
      <h2>无法获取最终合同</h2>
      <p>{{ loadError }}</p>
      <el-button type="primary" @click="loadDocument">重新加载</el-button>
      <el-button @click="goBack">返回填写页</el-button>
    </div>
  </div>
</template>

<script>
import { GetDepartmentDocument } from "@/api/home";
import { renderDepartmentDocuments } from "@/utils/departmentDocumentPrint";

export default {
  name: "DepartmentDocumentsPrint",
  data() {
    return {
      payload: null,
      loading: true,
      loadError: "",
    };
  },
  computed: {
    documentHtml() {
      return this.payload ? renderDepartmentDocuments(this.payload) : "";
    },
  },
  created() {
    this.loadDocument();
  },
  methods: {
    normalizeDocs(docs) {
      const values = Array.isArray(docs) ? docs : String(docs || "").split(",");
      return ["health", "profile"].filter(item => values.includes(item));
    },
    errorMessage(error, fallback) {
      return (error.response && error.response.data && error.response.data.msg) || error.message || fallback;
    },
    async loadDocument() {
      const unionId = String(this.$route.query.union_id || "").trim();
      this.payload = null;
      this.loadError = "";
      if (!unionId) {
        this.loading = false;
        this.loadError = "链接缺少 union_id，请返回填写页。";
        return;
      }
      this.loading = true;
      try {
        const response = await GetDepartmentDocument(unionId);
        const data = response.data || {};
        const docs = this.normalizeDocs(data.docs);
        if (!data.union_id || docs.length === 0) throw new Error("签署任务数据不完整");
        if (Number(data.status) === 3) throw new Error("签署链接已作废");
        this.payload = {
          union_id: data.union_id,
          student_id: data.student_id,
          title: data.title || "未命名学生",
          docs,
          status: Number(data.status || 0),
          submitted_at: data.submitted_at || null,
          health: data.health || null,
          profile: data.profile || null,
        };
      } catch (error) {
        this.loadError = this.errorMessage(error, "获取签署任务失败，请稍后重试。");
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      const unionId = String(this.$route.query.union_id || "").trim();
      if (unionId) {
        this.$router.push({ path: "/department-documents", query: { union_id: unionId } });
      } else {
        this.$router.push("/");
      }
    },
    savePdf() {
      window.print();
    },
  },
};
</script>

<style lang="scss">
.department-print-page { min-height: 100vh; padding: 24px; color: #172033; background: #e6ebf1; box-sizing: border-box; }
.print-toolbar { position: sticky; top: 0; z-index: 10; display: flex; align-items: center; justify-content: space-between; max-width: 1050px; margin: 0 auto 18px; padding: 12px 18px; border-radius: 8px; background: rgba(255,255,255,.96); box-shadow: 0 6px 22px rgba(30,45,65,.1); }
.print-toolbar > div { display: flex; align-items: center; gap: 12px; }
.pdf-actions { justify-content: flex-end; }
.pdf-actions span { color: #718095; font-size: 12px; }
.print-preview { max-width: 920px; margin: 0 auto; }
.print-sheet { min-height: 1120px; padding: 55px 64px; background: #fff; box-shadow: 0 10px 35px rgba(22,34,51,.12); box-sizing: border-box; }
.print-sheet h1, .print-sheet h2 { margin: 0; text-align: center; }
.print-sheet h1 { font-size: 28px; letter-spacing: .03em; }
.print-sheet h2 { margin-top: 5px; font-size: 20px; font-weight: 500; }
.print-meta { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 30px; margin: 34px 0 20px; border-top: 1px solid #26384f; }
.print-field { display: grid; grid-template-columns: minmax(150px, 42%) 1fr; gap: 12px; min-height: 38px; padding: 9px 0; border-bottom: 1px solid #cfd7e1; box-sizing: border-box; }
.print-field-label { color: #526174; font-size: 12px; }
.print-field-value { color: #111827; line-height: 1.5; overflow-wrap: anywhere; }
.print-section-title { margin: 28px 0 12px; padding: 9px 12px; border-left: 4px solid #315f8d; color: #1f3550; background: #eef3f8; font-size: 15px; font-weight: 700; }
.print-question { padding: 12px 0; border-bottom: 1px solid #d9e0e8; break-inside: avoid; }
.print-question-head { display: flex; flex-wrap: wrap; align-items: center; gap: 7px; }
.print-number { display: inline-grid; width: 23px; height: 23px; place-items: center; border-radius: 50%; color: #fff; background: #315f8d; font-size: 11px; font-weight: 700; }
.print-answer { margin-left: auto; }
.print-choice { display: inline-block; margin-left: 6px; padding: 3px 8px; border: 1px solid #b8c3d0; border-radius: 3px; color: #7b8796; font-size: 11px; }
.print-choice.is-selected { border-color: #172033; color: #fff; background: #172033; }
.print-detail, .print-subline { display: flex; gap: 10px; margin: 8px 0 0 30px; color: #566477; font-size: 12px; line-height: 1.6; }
.print-subline { align-items: center; }
.print-options { display: flex; flex-wrap: wrap; gap: 12px; margin: 9px 0 0 30px; }
.print-checkbox { font-size: 12px; }
.print-no-illness { margin-top: 8px; padding: 14px; background: #eef8f1; }
.print-declaration { margin-top: 24px; padding: 14px 18px; border: 1px solid #cfd7e1; font-size: 12px; line-height: 1.7; }
.print-declaration p { margin: 5px 0; }
.print-signatures { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 34px; margin-top: 28px; }
.print-signature-image { display: grid; height: 120px; margin: 9px 0; place-items: center; border-bottom: 1px solid #536276; }
.print-signature-image img { max-width: 100%; max-height: 115px; object-fit: contain; }
.print-signature .print-field { grid-template-columns: 130px 1fr; }
.print-field-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 28px; }
.print-long-field { margin: 14px 0; padding: 14px; border: 1px solid #d7dee7; break-inside: avoid; }
.print-long-field p { min-height: 50px; margin: 8px 0 0; line-height: 1.7; white-space: pre-wrap; }
.print-photos { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
.print-photos figure { margin: 0; padding: 8px; border: 1px solid #d6dee8; break-inside: avoid; }
.print-photos img { display: block; width: 100%; height: 240px; object-fit: contain; }
.print-photos figcaption { margin-top: 6px; color: #758295; text-align: center; font-size: 11px; }
.print-empty { color: #9aa5b2; }
.print-empty-block, .print-missing { padding: 50px; color: #748195; background: #fff; text-align: center; }
.print-missing { max-width: 920px; min-height: 260px; margin: 0 auto; box-sizing: border-box; }
.print-error { border-top: 4px solid #d45d5d; }
.print-page-break { height: 24px; }
@media (max-width: 767px) {
  .department-print-page { padding: 8px; }
  .print-toolbar { position: static; align-items: stretch; flex-direction: column; gap: 8px; }
  .pdf-actions { align-items: stretch !important; flex-direction: column; }
  .print-sheet { min-height: 0; padding: 30px 20px; }
  .print-meta, .print-field-grid, .print-signatures, .print-photos { grid-template-columns: 1fr; }
}
@media print {
  @page { size: A4; margin: 12mm; }
  .department-print-page { padding: 0; background: #fff; }
  .print-toolbar { display: none; }
  .print-preview { max-width: none; }
  .print-sheet { min-height: 0; padding: 0; box-shadow: none; }
  .print-page-break { height: 0; break-before: page; page-break-before: always; }
}
</style>
